import i18n, { onLanguageChange } from '../i18n';
import { useEffect } from 'react';

// Definizione delle chiavi di traduzione
export const categoryKeys = {
  // Categorie principali
  "Guitars": "categories.guitars",
  "Pedals and Amplifiers": "categories.pedalsAmplifiers",
  "Keyboards and Synths": "categories.keyboardsSynths",
  "Recording Gear": "categories.recordingGear",
  "Drums": "categories.drums",
  "DJ and Audio Gear": "categories.djAudioGear",
  "Video": "categories.video",
  "Lights and Effects": "categories.lightsEffects",
  
  // Sottocategorie
  "Electric": "categories.electric",
  "Acoustic": "categories.acoustic",
  "Bass": "categories.bass",
  "Other": "categories.other",
  "Guitar Pedals": "categories.guitarPedals",
  "Bass Pedals": "categories.bassPedals",
  "Amplifiers": "categories.amplifiers",
  "Cabinets": "categories.cabinets",
  "Keyboards": "categories.keyboards",
  "Synthesizers": "categories.synthesizers",
  "Organs": "categories.organs",
  "Microphones": "categories.microphones",
  "Interfaces": "categories.interfaces",
  "Mixers": "categories.mixers",
  "Monitors": "categories.monitors",
  "Acoustic Drums": "categories.acousticDrums",
  "Electronic Drums": "categories.electronicDrums",
  "Percussion": "categories.percussion",
  "Hardware": "categories.hardware",
  "DJ Controllers": "categories.djControllers",
  "Turntables": "categories.turntables",
  "Speakers": "categories.speakers",
  "Headphones": "categories.headphones",
  "Cameras": "categories.cameras",
  "Lenses": "categories.lenses",
  "Switchers": "categories.switchers",
  "Projectors": "categories.projectors",
  "Stage Lights": "categories.stageLights",
  "Effect Lights": "categories.effectLights",
  "Controllers": "categories.controllers",
  "Fog and Haze": "categories.fogHaze",
  "Accessories": "categories.accessories",
  
  // Tipi specifici
  "Solid Body": "categories.solidBody",
  "Semi-Hollow": "categories.semiHollow",
  "Hollow Body": "categories.hollowBody",
  "Steel String": "categories.steelString",
  "Classical (Nylon String)": "categories.classical",
  "Electro-Acoustic": "categories.electroAcoustic",
  "4-String": "categories.fourString",
  "5-String": "categories.fiveString",
  "Fretless": "categories.fretless",
  "Resonator": "categories.resonator",
  "Ukulele": "categories.ukulele",
  "Mandolin": "categories.mandolin",
  "Overdrive": "categories.overdrive",
  "Distortion": "categories.distortion",
  "Delay": "categories.delay",
  "Reverb": "categories.reverb",
  "Chorus": "categories.chorus",
  "Wah": "categories.wah",
  "Compressor": "categories.compressor",
  "Octaver": "categories.octaver",
  "Envelope Filter": "categories.envelopeFilter",
  "Tube Amp": "categories.tubeAmp",
  "Solid State Amp": "categories.solidStateAmp",
  "Modeling Amp": "categories.modelingAmp",
  "Bass Amp": "categories.bassAmp",
  "1x12": "categories.cab1x12",
  "2x12": "categories.cab2x12",
  "4x12": "categories.cab4x12",
  "Bass Cabinet": "categories.bassCabinet",
  "Stage Piano": "categories.stagePiano",
  "MIDI Controller": "categories.midiController",
  "Workstation": "categories.workstation",
  "Analog": "categories.analog",
  "Digital": "categories.digital",
  "Modular": "categories.modular",
  "Hammond": "categories.hammond",
  "Combo Organ": "categories.comboOrgan",
  "Sustain Pedal": "categories.sustainPedal",
  "Expression Pedal": "categories.expressionPedal",
  "Keyboard Stand": "categories.keyboardStand",
  "Dynamic": "categories.dynamic",
  "Condenser": "categories.condenser",
  "Ribbon": "categories.ribbon",
  "Shotgun": "categories.shotgun",
  "USB": "categories.usb",
  "Thunderbolt": "categories.thunderbolt",
  "Rack-mounted": "categories.rackMounted",
  "Studio Monitors": "categories.studioMonitors",
  "Mic Stands": "categories.micStands",
  "Pop Filters": "categories.popFilters",
  "DI Boxes": "categories.diBoxes",
  "Kick": "categories.kick",
  "Snare": "categories.snare",
  "Toms": "categories.toms",
  "Cymbals": "categories.cymbals",
  "Full Kits": "categories.fullKits",
  "Drum Pads": "categories.drumPads",
  "Triggers": "categories.triggers",
  "Cajon": "categories.cajon",
  "Bongos": "categories.bongos",
  "Congas": "categories.congas",
  "Tambourine": "categories.tambourine",
  "Drum Stands": "categories.drumStands",
  "Pedals": "categories.pedals",
  "Thrones": "categories.thrones",
  "All-in-One": "categories.allInOne",
  "Modular DJ": "categories.modularDj",
  "Direct Drive": "categories.directDrive",
  "Belt Drive": "categories.beltDrive",
  "2-Channel": "categories.twoChannel",
  "4-Channel": "categories.fourChannel",
  "PA Speakers": "categories.paSpeakers",
  "Subwoofers": "categories.subwoofers",
  "DJ Headphones": "categories.djHeadphones",
  "In-Ear Monitors": "categories.inEarMonitors",
  "Cables": "categories.cables",
  "Cases": "categories.cases",
  "Stands": "categories.stands",
  "DSLR": "categories.dslr",
  "Mirrorless": "categories.mirrorless",
  "Cinema Camera": "categories.cinemaCamera",
  "PTZ": "categories.ptz",
  "Wide Angle": "categories.wideAngle",
  "Standard": "categories.standard",
  "Telephoto": "categories.telephoto",
  "Software-based": "categories.softwareBased",
  "Hardware-based": "categories.hardwareBased",
  "Short Throw": "categories.shortThrow",
  "Long Throw": "categories.longThrow",
  "Tripods": "categories.tripods",
  "Gimbals": "categories.gimbals",
  "Capture Cards": "categories.captureCards",
  "PAR Lights": "categories.parLights",
  "Moving Heads": "categories.movingHeads",
  "Fresnels": "categories.fresnels",
  "Lasers": "categories.lasers",
  "Strobe Lights": "categories.strobeLights",
  "DMX Controllers": "categories.dmxControllers",
  "Fog Machines": "categories.fogMachines",
  "Haze Machines": "categories.hazeMachines",
  "Clamps": "categories.clamps",
  "Safety Cables": "categories.safetyCables"
};

// Crea il dizionario inverso per cercare le chiavi dai valori tradotti
export const createReverseKeyMap = () => {
  const reverseMap: Record<string, string> = {};
  
  // Per ogni lingua supportata, crea mappature per ogni chiave
  ['it', 'en'].forEach(lang => {
    // Salva la lingua corrente
    const currentLang = i18n.language;
    // Cambia temporaneamente la lingua per ottenere le traduzioni
    i18n.changeLanguage(lang);
    
    // Crea le mappature per questa lingua
    Object.entries(categoryKeys).forEach(([englishKey, translationKey]) => {
      const translatedValue = i18n.t(translationKey);
      // La chiave nel reverseMap è il valore tradotto, il valore è la chiave di traduzione
      reverseMap[translatedValue] = translationKey;
    });
    
    // Ripristina la lingua originale
    i18n.changeLanguage(currentLang);
  });
  
  return reverseMap;
};

// Cache per la mappa inversa
let reverseKeyMapCache: Record<string, string> | null = null;

// Funzione per ottenere la mappa inversa (con cache)
export const getReverseKeyMap = () => {
  if (!reverseKeyMapCache) {
    reverseKeyMapCache = createReverseKeyMap();
  }
  return reverseKeyMapCache;
};

// Resetta la cache quando cambia la lingua
if (typeof window !== 'undefined') {
  onLanguageChange(() => {
    reverseKeyMapCache = null;
  });
}

// Funzione per convertire il valore tradotto nella chiave di traduzione
export const getTranslationKeyFromValue = (translatedValue: string): string => {
  const reverseMap = getReverseKeyMap();
  return reverseMap[translatedValue] || translatedValue;
};

// Funzione per convertire la chiave di traduzione nel valore tradotto
export const getTranslatedValueFromKey = (translationKey: string): string => {
  return i18n.t(translationKey, { defaultValue: translationKey });
};

// Funzione helper per tradurre
const t = (key: string): string => {
  return i18n.t(key, { defaultValue: key.split('.').pop() });
};

// Funzione per ottenere le categorie tradotte
export const getTranslatedCategories = () => {
  const translatedStruct = {
    [t(categoryKeys["Guitars"])]: {
      [t(categoryKeys["Electric"])]: [t(categoryKeys["Solid Body"]), t(categoryKeys["Semi-Hollow"]), t(categoryKeys["Hollow Body"])],
      [t(categoryKeys["Acoustic"])]: [t(categoryKeys["Steel String"]), t(categoryKeys["Classical (Nylon String)"]), t(categoryKeys["Electro-Acoustic"])],
      [t(categoryKeys["Bass"])]: [t(categoryKeys["4-String"]), t(categoryKeys["5-String"]), t(categoryKeys["Fretless"])],
      [t(categoryKeys["Other"])]: [t(categoryKeys["Resonator"]), t(categoryKeys["Ukulele"]), t(categoryKeys["Mandolin"])]
    },
    [t(categoryKeys["Pedals and Amplifiers"])]: {
      [t(categoryKeys["Guitar Pedals"])]: [t(categoryKeys["Overdrive"]), t(categoryKeys["Distortion"]), t(categoryKeys["Delay"]), t(categoryKeys["Reverb"]), t(categoryKeys["Chorus"]), t(categoryKeys["Wah"])],
      [t(categoryKeys["Bass Pedals"])]: [t(categoryKeys["Compressor"]), t(categoryKeys["Octaver"]), t(categoryKeys["Envelope Filter"])],
      [t(categoryKeys["Amplifiers"])]: [t(categoryKeys["Tube Amp"]), t(categoryKeys["Solid State Amp"]), t(categoryKeys["Modeling Amp"]), t(categoryKeys["Bass Amp"])],
      [t(categoryKeys["Cabinets"])]: [t(categoryKeys["1x12"]), t(categoryKeys["2x12"]), t(categoryKeys["4x12"]), t(categoryKeys["Bass Cabinet"])]
    },
    [t(categoryKeys["Keyboards and Synths"])]: {
      [t(categoryKeys["Keyboards"])]: [t(categoryKeys["Stage Piano"]), t(categoryKeys["MIDI Controller"]), t(categoryKeys["Workstation"])],
      [t(categoryKeys["Synthesizers"])]: [t(categoryKeys["Analog"]), t(categoryKeys["Digital"]), t(categoryKeys["Modular"])],
      [t(categoryKeys["Organs"])]: [t(categoryKeys["Hammond"]), t(categoryKeys["Combo Organ"])],
      [t(categoryKeys["Accessories"])]: [t(categoryKeys["Sustain Pedal"]), t(categoryKeys["Expression Pedal"]), t(categoryKeys["Keyboard Stand"])]
    },
    [t(categoryKeys["Recording Gear"])]: {
      [t(categoryKeys["Microphones"])]: [t(categoryKeys["Dynamic"]), t(categoryKeys["Condenser"]), t(categoryKeys["Ribbon"]), t(categoryKeys["Shotgun"])],
      [t(categoryKeys["Interfaces"])]: [t(categoryKeys["USB"]), t(categoryKeys["Thunderbolt"]), t(categoryKeys["Rack-mounted"])],
      [t(categoryKeys["Mixers"])]: [t(categoryKeys["Analog"]), t(categoryKeys["Digital"])],
      [t(categoryKeys["Monitors"])]: [t(categoryKeys["Studio Monitors"]), t(categoryKeys["Headphones"])],
      [t(categoryKeys["Accessories"])]: [t(categoryKeys["Mic Stands"]), t(categoryKeys["Pop Filters"]), t(categoryKeys["DI Boxes"])]
    },
    [t(categoryKeys["Drums"])]: {
      [t(categoryKeys["Acoustic Drums"])]: [t(categoryKeys["Kick"]), t(categoryKeys["Snare"]), t(categoryKeys["Toms"]), t(categoryKeys["Cymbals"])],
      [t(categoryKeys["Electronic Drums"])]: [t(categoryKeys["Full Kits"]), t(categoryKeys["Drum Pads"]), t(categoryKeys["Triggers"])],
      [t(categoryKeys["Percussion"])]: [t(categoryKeys["Cajon"]), t(categoryKeys["Bongos"]), t(categoryKeys["Congas"]), t(categoryKeys["Tambourine"])],
      [t(categoryKeys["Hardware"])]: [t(categoryKeys["Drum Stands"]), t(categoryKeys["Pedals"]), t(categoryKeys["Thrones"])]
    },
    [t(categoryKeys["DJ and Audio Gear"])]: {
      [t(categoryKeys["DJ Controllers"])]: [t(categoryKeys["All-in-One"]), t(categoryKeys["Modular DJ"])],
      [t(categoryKeys["Turntables"])]: [t(categoryKeys["Direct Drive"]), t(categoryKeys["Belt Drive"])],
      [t(categoryKeys["Mixers"])]: [t(categoryKeys["2-Channel"]), t(categoryKeys["4-Channel"])],
      [t(categoryKeys["Speakers"])]: [t(categoryKeys["PA Speakers"]), t(categoryKeys["Subwoofers"])],
      [t(categoryKeys["Headphones"])]: [t(categoryKeys["DJ Headphones"]), t(categoryKeys["In-Ear Monitors"])],
      [t(categoryKeys["Accessories"])]: [t(categoryKeys["Cables"]), t(categoryKeys["Cases"]), t(categoryKeys["Stands"])]
    },
    [t(categoryKeys["Video"])]: {
      [t(categoryKeys["Cameras"])]: [t(categoryKeys["DSLR"]), t(categoryKeys["Mirrorless"]), t(categoryKeys["Cinema Camera"]), t(categoryKeys["PTZ"])],
      [t(categoryKeys["Lenses"])]: [t(categoryKeys["Wide Angle"]), t(categoryKeys["Standard"]), t(categoryKeys["Telephoto"])],
      [t(categoryKeys["Switchers"])]: [t(categoryKeys["Software-based"]), t(categoryKeys["Hardware-based"])],
      [t(categoryKeys["Projectors"])]: [t(categoryKeys["Short Throw"]), t(categoryKeys["Long Throw"])],
      [t(categoryKeys["Accessories"])]: [t(categoryKeys["Tripods"]), t(categoryKeys["Gimbals"]), t(categoryKeys["Capture Cards"])]
    },
    [t(categoryKeys["Lights and Effects"])]: {
      [t(categoryKeys["Stage Lights"])]: [t(categoryKeys["PAR Lights"]), t(categoryKeys["Moving Heads"]), t(categoryKeys["Fresnels"])],
      [t(categoryKeys["Effect Lights"])]: [t(categoryKeys["Lasers"]), t(categoryKeys["Strobe Lights"])],
      [t(categoryKeys["Controllers"])]: [t(categoryKeys["DMX Controllers"]), t(categoryKeys["Software-based"])],
      [t(categoryKeys["Fog and Haze"])]: [t(categoryKeys["Fog Machines"]), t(categoryKeys["Haze Machines"])],
      [t(categoryKeys["Accessories"])]: [t(categoryKeys["Clamps"]), t(categoryKeys["Cables"]), t(categoryKeys["Safety Cables"])]
    }
  } as const;

  // Converte la struttura costante in una struttura modificabile per compatibilità
  return convertConstToMutableCategories(translatedStruct);
};

/**
 * Converte le categorie di sola lettura in categorie modificabili
 * per garantire compatibilità con l'interfaccia attesa dai componenti
 */
export const convertConstToMutableCategories = (constCategories: any): Record<string, Record<string, string[]>> => {
  const result: Record<string, Record<string, string[]>> = {};
  
  try {
    Object.keys(constCategories).forEach(mainCat => {
      result[mainCat] = {};
      
      Object.keys(constCategories[mainCat]).forEach(subCat => {
        // Converti gli array di sola lettura in array normali
        result[mainCat][subCat] = Array.from(constCategories[mainCat][subCat]);
      });
    });
    
    return result;
  } catch (error) {
    console.error('Error converting categories:', error);
    // Restituisci un oggetto vuoto in caso di errore
    return {};
  }
};

// Definisco l'oggetto categories statico (fallback se getTranslatedCategories fallisce)
export const categories = {
  "Guitars": {
    "Electric": ["Solid Body", "Semi-Hollow", "Hollow Body"],
    "Acoustic": ["Steel String", "Classical (Nylon String)", "Electro-Acoustic"],
    "Bass": ["4-String", "5-String", "Fretless"],
    "Other": ["Resonator", "Ukulele", "Mandolin"]
  },
  "Pedals and Amplifiers": {
    "Guitar Pedals": ["Overdrive", "Distortion", "Delay", "Reverb", "Chorus", "Wah"],
    "Bass Pedals": ["Compressor", "Octaver", "Envelope Filter"],
    "Amplifiers": ["Tube Amp", "Solid State Amp", "Modeling Amp", "Bass Amp"],
    "Cabinets": ["1x12", "2x12", "4x12", "Bass Cabinet"]
  },
  "Keyboards and Synths": {
    "Keyboards": ["Stage Piano", "MIDI Controller", "Workstation"],
    "Synthesizers": ["Analog", "Digital", "Modular"],
    "Organs": ["Hammond", "Combo Organ"],
    "Accessories": ["Sustain Pedal", "Expression Pedal", "Keyboard Stand"]
  },
  "Recording Gear": {
    "Microphones": ["Dynamic", "Condenser", "Ribbon", "Shotgun"],
    "Interfaces": ["USB", "Thunderbolt", "Rack-mounted"],
    "Mixers": ["Analog", "Digital"],
    "Monitors": ["Studio Monitors", "Headphones"],
    "Accessories": ["Mic Stands", "Pop Filters", "DI Boxes"]
  },
  "Drums": {
    "Acoustic Drums": ["Kick", "Snare", "Toms", "Cymbals"],
    "Electronic Drums": ["Full Kits", "Drum Pads", "Triggers"],
    "Percussion": ["Cajon", "Bongos", "Congas", "Tambourine"],
    "Hardware": ["Drum Stands", "Pedals", "Thrones"]
  },
  "DJ and Audio Gear": {
    "DJ Controllers": ["All-in-One", "Modular DJ"],
    "Turntables": ["Direct Drive", "Belt Drive"],
    "Mixers": ["2-Channel", "4-Channel"],
    "Speakers": ["PA Speakers", "Subwoofers"],
    "Headphones": ["DJ Headphones", "In-Ear Monitors"],
    "Accessories": ["Cables", "Cases", "Stands"]
  },
  "Video": {
    "Cameras": ["DSLR", "Mirrorless", "Cinema Camera", "PTZ"],
    "Lenses": ["Wide Angle", "Standard", "Telephoto"],
    "Switchers": ["Software-based", "Hardware-based"],
    "Projectors": ["Short Throw", "Long Throw"],
    "Accessories": ["Tripods", "Gimbals", "Capture Cards"]
  },
  "Lights and Effects": {
    "Stage Lights": ["PAR Lights", "Moving Heads", "Fresnels"],
    "Effect Lights": ["Lasers", "Strobe Lights"],
    "Controllers": ["DMX Controllers"],
    "Fog and Haze": ["Fog Machines", "Haze Machines"],
    "Accessories": ["Clamps", "Safety Cables"]
  }
};

export type MainCategory = keyof typeof categories;
export type SubCategory<T extends MainCategory> = keyof typeof categories[T];
export type ItemType<T extends MainCategory, S extends SubCategory<T>> = string;

export interface CategoryOption {
  main: MainCategory;
  sub: string;
  type: string;
} 